import cohortsTab from './cohortsTab';
import systemCohortTab from '../system/layout/systemCohortTab';
import newCohortTab from './newCohortTab';
import cohortTab from './cohortTab';
import cohortHistoryTab from './cohortHistoryTab';
import cohortRequestTab from './cohortRequestTab';

export default [
  cohortHistoryTab,
  cohortRequestTab,
  cohortsTab,
  cohortTab,
  newCohortTab,
  systemCohortTab,
];
